import { Environment } from "./env";

export const DemoEnvironment: Environment = {
    base_url: "https://aps-cus-connect-demo-api-01.azurewebsites.net",
    temp_base_url: "https://aps-cus-connect-demo-api-01.azurewebsites.net",
};
